/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DataLockLevel {
  None = 'None',
  Full = 'Full',
  Partial = 'Partial'
}
